import { bool, object, string, ValidationError } from 'yup'

import { validateField, validateValues } from 'shared/utils/form'

type NewsletterValues = {
  email: string
  newsletterAgreement: boolean
}

export const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/

// REGISTRATION
export const newsletterSchema = object().shape({
  email: string()
    .required('Email jest wymagany')
    .matches(emailRegex, 'Niepoprawny adres email')
    .email('Niepoprawny adres email'),
  newsletterAgreement: bool().required(
    'Aby kontynuować musisz zaakceptować regulamin'
  )
})

export const validateNewsletterField = (values: Partial<NewsletterValues>) =>
  validateField(newsletterSchema, values)

export const validateNewsletterValues = validateValues(newsletterSchema)

export const validateNewsletterSchema = async (values: NewsletterValues) => {
  try {
    await newsletterSchema.validate(values, { abortEarly: false })

    return { valid: true, errors: null }
  } catch (err) {
    const validationError = err as ValidationError

    return { valid: false, errors: validationError.inner }
  }
}
